const { client, loadToken } = require('./client');
export { loadToken };


//feed 1
/// pure siri type feed
export async function getPubSub(stop_id) {
  var { data } = await client.get(`/gtfs/pub_sub/${stop_id}`);

  return data;
}


///feed 2 and 3
export async function getRealtime(agency, stop_id) {
  var { data } = await client.post(`api/gtfs/realtime/${agency}/${stop_id}`);

  return data;
}

export async function getStatic(agency, stop_id) {
  var { data } = await client.get(`api/gtfs/static/${agency}/${stop_id}`);

  return data;
}

export async function getAssignedTags() {
  var { data } = await client.get('/gtfs/tags/assigned');
  return data;
}

export async function getTags() {
  var { data } = await client.get('/gtfs/tags');
  return data;
}

const all = { loadToken, getRealtime, getTags, getAssignedTags, getPubSub };

export default all;